export default "__VITE_ASSET__DR0U_X$b__"